import React, {Component} from 'react';
import ReactDOM from "react-dom";
import {Link, withRouter} from 'react-router-dom';
import {translate} from 'react-i18next';
import RegisterView from '../Customer/Auth/RegisterView';
import PropTypes from 'prop-types';
import CounterView from '../Counter/CounterView';
import {
  getCartDealDetails,
  getFormatPrice,
  getPizzaExtraIngredients,
  getProductOption,
} from '../../helpers';
import PickUpTimeLayout from '../../containers/PickUpTime';
import {LIMIT_COST_FOR_CASH} from '../../constants';
import classNames from 'classnames';
import momentDuration from 'moment-duration-format';
import moment from 'moment/moment';

class ProductCartRecapView extends Component {

  constructor(props) {
    super(props);
    this.confirm = this.confirm.bind(this);
    this.changePayment = this.changePayment.bind(this);
    this.canConfirm = this.canConfirm.bind(this);
    this.state = {
      payment: null,
    };
    this.timeLeftRef = React.createRef();

    momentDuration(moment);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const result = {};
    if (nextProps.totalCost > LIMIT_COST_FOR_CASH && prevState.payment === 'cash') {
      result.payment = 'card';
    }
    return result;
  }

  componentDidUpdate(prevProps) {
    if (this.props.timeLeft < 0) {
      const formNode = ReactDOM.findDOMNode(this.timeLeftRef.current);
      formNode.scrollIntoView(true);
    }
  }

  confirm(event) {
    event.preventDefault();

    const {confirmOrder, restaurant} = this.props;
    const {payment} = this.state;

    const data = {
      restaurantId: restaurant.id,
      payment: payment,
      takeAway: 'take_away',
    };
    confirmOrder(data);
  }

  changePayment(method) {
    this.setState({
      payment: method,
    });
  }

  isType(item, type) {
    return item.typeProduct === type;
  }

  canCustomize(item) {
    return (this.isType(item, 'pizza') && !item.product.is_special_pizza) || this.isType(item, 'deals');
  }

  canConfirm() {
    const {basketList, logged, timeLeft, inProgress} = this.props;
    const {payment} = this.state;
    return !!basketList.length && payment && logged && timeLeft > 0 && !inProgress;
  }

  render() {
    const {
      restaurant, basketList, totalCost, onRemove, language, t, closeBasket,
      inProgress, ingredients, timeLeft, onTimeChange, increase, decrease, registerUser, refRegistration, errors, logged,
    } = this.props;
    const url = `/${language}/${restaurant.name_for_url}/products/pizza`;
    return (
        <div>
          {!logged &&
          <RegisterView
            recapPage={true}
            action={registerUser}
            errors={errors}
            inProgress={inProgress}
            ref={refRegistration}
            language={language}
          />
          }
          <div className="cart">
            <div className="cart__panel">
              <div className="cart__title">
                {t('voteCart')}
                <button onClick={closeBasket} className="cart__title-btn">
                </button>
              </div>
              {!!basketList.length &&
              <div className="cart__row">
                <div className="cart__select">
                  <div>{restaurant.name}</div>
                  <div className="cart__select-note cart__select-note--marked">
                    {t('takeAway')}
                  </div>
                </div>
                <PickUpTimeLayout
                    classNames='cart__select'
                    onChangeTime={onTimeChange}
                    ref={this.timeLeftRef}
                />
                {timeLeft >= 0 ?
                    <div className="cart__select-note">
                      {t('take_time_pizza', {
                        minute: moment.duration(timeLeft, 'seconds').format('hh[h] mm[m] ss[s]'),
                      })}
                    </div>
                    :
                    <div className="cart__errors">
                      {t('please_choose_time')}
                    </div>
                }
              </div>
              }
              <div className="cart__row">
                <div className="cart__total-info">
                  {t('voteCart')}
                  <small>{basketList.length} {basketList.length === 1 ? t('item') : t('items')}</small>
                  <span className="cart-item__link">
                  <Link to={url}>{t('change_order')}</Link>
                  </span>
                </div>
              </div>
              {!!basketList.length &&
              <div className="cart__row cart__row--has-scroller">
                <div className="cart__scroller">
                  {basketList.map((obj, index) => (
                      <div className="cart__row" key={index}>
                        <div className="cart-item cart-item--detailed">
                          <div className="cart-item__image">
                            <img src={obj.product.photo_mini_thumbnail}
                                 alt={obj.product[`name_${language}`]}/>
                          </div>
                          <div className="cart-item__content">
                            <div className="cart-item__row">
                              <div className="cart-item__counter">
                                <div className="counter counter--reduced">
                                  <CounterView
                                    increase={() => increase(obj)}
                                    decrease={() => decrease(obj)}
                                    value={obj.quantity}
                                  />
                                </div>
                              </div>
                              <div
                                  className="cart-item__title">{obj.product[`name_${language}`]}</div>
                              {obj.crustID && obj.crustName && obj.typeProduct === 'pizza' &&
                              <div className="cart-item__details">{obj.crustName}
                                {!obj.product.is_special_pizza &&
                                  <React.Fragment>
                                    <span className='divider'>|</span>
                                    {t(obj.size)}
                                  </React.Fragment>
                                }
                              </div>
                              }
                              {this.isType(obj, 'pizza') &&
                              <div className="cart-item__details">
                                {getPizzaExtraIngredients(obj, ingredients, language)
                                    .map((ingredient, dataIndex) => (
                                        <div key={dataIndex}>
                                          {ingredient.sign} {ingredient.name} x {ingredient.amount}
                                        </div>
                                    ))}
                              </div>
                              }
                              {this.isType(obj, 'deals') && <div
                                  className="cart-item__details">
                                {getCartDealDetails(restaurant, obj, language)
                                    .map((data, dataIndex) => (
                                        <div key={dataIndex}>{t('cart_deal_detail', data)}</div>
                                    ))}
                              </div>}
                              {this.isType(obj, 'product') && <div
                                  className="cart-item__details">
                                {getProductOption(obj, language).map((option, optionIndex) => (
                                    <span key={optionIndex}>
                                      {option}{getProductOption(obj, language).length > 1 &&
                                    optionIndex < getProductOption(obj, language).length - 1 &&
                                    ' | '}</span>
                                ))}
                              </div>}
                            </div>
                            <div className="cart-item__row-flex">
                              <div className="cart-item__link">
                                {this.canCustomize(obj) &&
                                <Link
                                    to={{
                                      pathname: `/${language}/${restaurant.name_for_url}/products/${obj.typeProduct}/customize/${obj.product.id}`,
                                      state: {
                                        ...obj,
                                        action: 'update',
                                      },
                                    }}
                                    className="cart-item__link">{t('customize')}</Link>
                                }
                                <Link
                                    to='#'
                                    onClick={() => onRemove(obj.typeProduct, obj.index)}
                                    className="cart-item__link cart-item__link--red">
                                  {t('removeFromBasket')}
                                </Link>
                              </div>
                              <span className="cart-item__price">{getFormatPrice(
                                  obj.cost)}€ TTC</span>
                            </div>
                          </div>
                        </div>
                      </div>
                  ))}
                </div>
              </div>
              }
              {!basketList.length &&
              <div className="cart__row">
                {t('emptyBasket')}
              </div>
              }
              {/* TODO promo code not implemented yet */}
              {false &&
              <div className="cart__row">
                <div className="cart__promo">
                  <label>Code promo :</label>
                  <input className="cart__promo-input" type="text"
                         placeholder="Insérez votre code promo ici ..."/>
                </div>
                <small>{t('get_coupon')}</small>
              </div>
              }
              <div className="cart__total">
                {t('totalCost')}: <span className="cart__price">{getFormatPrice(
                  totalCost)}€ {!!basketList.length && 'TTC'}</span>
              </div>
              {totalCost > LIMIT_COST_FOR_CASH && <div className="cart__info">
                {t('cash_not_available', {limit: LIMIT_COST_FOR_CASH})}
              </div>
              }
              {errors && errors.saferpay && <div className="cart__errors">
                {t('credit_cart_error')}
              </div>}
              {errors && errors.detail && <div className="cart__errors">
                {t('credit_cart_error')}
              </div>}
            </div>
            <div className="cart__payment">
              <button
                  className={
                    classNames({
                      'cart__payment-type': true,
                      'cart__payment-type--active': this.state.payment === 'cash',
                    })}
                  onClick={() => this.changePayment('cash')}
              >
                <span className="icon icon-cash">
                </span>
                <span className="text">{t('cash')}</span>
              </button>
              {restaurant.allow_online_payment &&
                <button
                  className={
                    classNames({
                      'cart__payment-type': true,
                      'cart__payment-type--active': this.state.payment === 'card',
                    })}
                  onClick={() => this.changePayment('card')}
                >
                  <span className="icon icon-credit-card">
                  </span>
                  <span className="text">{t('credit_card')}</span>
                </button>
              }
            </div>
            <button
                className={classNames('cart__button', {
                  'touch-helper': !logged,
                })}
                disabled={!this.canConfirm()}
                onClick={this.confirm}>
              {t('confirm')}
              <span className="touch-helper__inner">{t('register_the_first')}</span>
            </button>
            <button className="cart__button cart__button--close" onClick={closeBasket}>
            </button>
          </div>
        </div>
    );
  }
}

ProductCartRecapView.propTypes = {
  logged: PropTypes.bool,
  restaurant: PropTypes.object,
  basketList: PropTypes.array,
  totalCost: PropTypes.number,
  onRemove: PropTypes.func,
  increase: PropTypes.func,
  decrease: PropTypes.func,
  language: PropTypes.string,
  registerUser: PropTypes.func,
  closeBasket: PropTypes.func,
  ingredients: PropTypes.array,
  onTimeChange: PropTypes.func,
  timeLeft: PropTypes.number,
  refRegistration: PropTypes.object,
  inProgress: PropTypes.bool,
  errors: PropTypes.object,
  confirmOrder: PropTypes.func,
};

export default withRouter(translate('translations')(ProductCartRecapView));


// WEBPACK FOOTER //
// ./src/components/Product/ProductCartRecapView.js